export default __webpack_public_path__ + "static/media/chi5.adf7a561.jpg";